import { Skeleton, Spin } from 'antd';
import clsx from 'clsx';
import Sidebar from '../../../components/Core/Sidebar';

interface LoadingOverlayProps {
  label: string;
  isVisible: boolean;
  hasSidebar?: boolean;
}

const LoadingOverlay = ({ label, isVisible, hasSidebar = true }: LoadingOverlayProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={clsx(
        'z-loading-overlay pointer-events-auto absolute inset-0 flex items-center justify-center opacity-100',
        'bg-background/80 backdrop-blur-sm transition duration-200 ease-in-out',
      )}
    >
      <div className="flex h-full w-full overflow-hidden">
        <header className="bg-gray-medium fixed top-0 right-0 left-0 z-40 h-14 w-screen" />
        {hasSidebar && (
          <Sidebar>
            <div className="flex w-full flex-1 flex-col items-center justify-center gap-4 px-3">
              <Skeleton.Input active block />
              <Skeleton.Input active size="small" block />
              <Skeleton.Input active size="small" block />
              <Skeleton.Input active size="small" block />
              <Skeleton.Input active size="small" block />
              <Skeleton.Input active size="small" block />
            </div>
          </Sidebar>
        )}

        <div
          className={clsx(
            'flex h-full w-full flex-col items-center justify-center gap-2 rounded-md p-4',
            hasSidebar ? 'ml-60px lg:ml-205px' : 'ml-0',
          )}
        >
          <div className="bg-background flex h-36 w-full"></div>
          <div className="flex h-full w-full flex-col items-center justify-center gap-2 rounded-md bg-white p-4">
            <Spin />
            <span className="ml-2 text-sm font-medium text-black">{label}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
